import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetMk8sClusterQuery } from "../../store/api/mk8sApi";
import { Mk8sDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "mk8s";
export const Mk8sDetailInitializer: React.FC = () => {
  const { org: orgName, mk8s: mk8sName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/mk8s/${mk8sName}`;

  const { data: mk8s, isLoading, isFetching, isError, error, refetch } = useGetMk8sClusterQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!mk8s && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="mk8s" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !mk8s) {
    return <IncorrectItem kind="mk8s" canCreate={true} />;
  }

  return <Mk8sDetailForm mk8s={mk8s} />;
};
